/**
 * winess-key-features.js
 *
 * Web Component that rebuilds the key-features bullet list when the customer
 * picks a different variant. Subscribes to the theme's
 * PUB_SUB_EVENTS.variantChange (published by product-info.js) and looks up the
 * new bullets from an inline JSON map keyed by variant id.
 *
 * Plain text only — each bullet is set via textContent (XSS-safe). The source
 * metafield is list.single_line_text_field, so HTML is not expected.
 */
class WinessKeyFeatures extends HTMLElement {
  constructor() {
    super();
    this.listEl = this.querySelector('[data-winess-key-features-list]');
    this.mapEl = this.querySelector('[data-winess-key-features-map]');
    this.sectionId = this.dataset.sectionId;
    this.map = {};

    if (this.mapEl) {
      try {
        this.map = JSON.parse(this.mapEl.textContent) || {};
      } catch (e) {
        this.map = {};
      }
    }
  }

  connectedCallback() {
    if (!this.listEl || typeof subscribe !== 'function') return;

    this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (!data || !data.variant) return;
      // Only react to changes within the same section (a PDP may share the page
      // with featured-product sections that also publish variantChange).
      if (this.sectionId && data.sectionId && String(data.sectionId) !== String(this.sectionId)) {
        return;
      }
      this.update(data.variant.id);
    });
  }

  disconnectedCallback() {
    if (typeof this.unsubscribe === 'function') this.unsubscribe();
  }

  update(variantId) {
    if (variantId == null) return;
    const features = this.map[String(variantId)];
    // Defensive: leave the current list in place if the variant has no bullets.
    if (!Array.isArray(features) || features.length === 0) return;

    const frag = document.createDocumentFragment();
    features.forEach((text) => {
      const li = document.createElement('li');
      li.textContent = text;
      frag.appendChild(li);
    });
    this.listEl.textContent = '';
    this.listEl.appendChild(frag);
  }
}

customElements.define('winess-key-features', WinessKeyFeatures);
